<input type="text" #inputText
  [style.width.px]="width" [style.width]="width !== undefined ? width : '7rem'"
	[class.text-label-required]="required" [style.font-size]="fontSize"
	[readonly]="!editable" [maxLength]="maxChars" plessInputTextSub [restrict]="restrict" [halfOnly]="true"
	[tabindex]="tabEnabled ? tabindex : -1" [(ngModel)]="text"
	[disabled]="disabled" [autofocus]="autofocus"
	(ngModelChange)="changeOrderCodeHandler();onChange($event);" (blur)="onTouched()" />
